<div class="mb-5">
  <app-ngb-table *ngIf="alertsTableData.length > 0" [config]="alertsTableConfig" [data]="alertsTableData"></app-ngb-table>
</div>
